import { useEffect, useState } from "react"
import { AvField } from "availity-reactstrap-validation"
import { Alert, Col, Row, Label, FormGroup } from "reactstrap"
import { Link } from "react-router-dom"

import Application from "services/applications/Application.service"
const BASE_URL = process.env.REACT_APP_BASE_URL

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const OfficerFormAccreditation = props => {
  const [officerSubmitted, setofficerSubmitted] = useState(false)
  const [showComments, setshowComments] = useState()
  const [comments, setcomments] = useState()
  const [minutesDocument, setminutesDocument] = useState(null)
  const [staffUploads, setstaffUploads] = useState([])
  const [showCertificatePreview, setshowCertificatePreview] = useState(false)


  const certPreviewUrl =
    BASE_URL + "verify/certificate/" + props.appDetails.app_id + "?preview=true"

  useEffect(() => {}, [])

  const decisionValueChange = value => {
    const commentsCodes = ["011", "012"]
    if (commentsCodes.includes(value)) {
      setshowComments(true)
    } else {
      setcomments("")
      setshowComments(false)
    }

    // show certificate preview
    if (value == "010") {
      setshowCertificatePreview(true)
    } else {
      setshowCertificatePreview(false)
    }
  }

  async function uploadDocuments() {
    if (minutesDocument) {
      const termsReport = {
        file: minutesDocument,
        application_id: props.appDetails.id,
        description: "Meeting_Minutes",
      }

      const response = await appService.uploadFile(termsReport)
    }
  }

  const handleFileChange = (event, setFile) => {
    const file = event.target.files[0]
    setFile(file)
  }

  return (
    <>
      <div>
        <AvField
          type="hidden"
          name="application_id"
          value={props.appDetails.id}
        />
      </div>

      <div>
        {props.error && props.error == true ? (
          <Row className="alert alert-danger">
            <Col md="12">{props.message}</Col>
          </Row>
        ) : null}

        {props.success && props.success == true ? (
          <Row className="alert alert-success">
            <Col md="8">{props.message}</Col>
            <Col md="4">
              <Link to="/dashboard" style={{ float: "right" }}>
                Back
              </Link>
            </Col>
          </Row>
        ) : null}
      </div>

      <div className="mb-3">
        <AvField
          disabled={props.success}
          type="select"
          name="decision_code"
          label="Select Decision"
          //value={defaultValues.decision_code}
          required
          onChange={v => {
            decisionValueChange(v.target.value)
          }}
        >
          <option value="">--select Decision--</option>
          <option value="010">Propose to Approve</option>

          <option value="011">Propose to Reject</option>
          <option value="012">Return to Applicant</option>
        </AvField>
      </div>

      <Row className="mb-3">
        <label htmlFor="reason" className="col-lg-3 col-form-label">
          Reason
        </label>
        <div className="col-lg-9">
          <AvField
            disabled={props.success}
            type="textarea"
            // value={defaultValues.reason}
            id="reason"
            name="reason"
            rows="2"
            required
            className="form-control"
          ></AvField>
        </div>
      </Row>

      {showCertificatePreview ? (
        <Row className="mb-3">
          <Alert color="info">
            Before submitting your review, please click on the preview link
            below to see how the certificate will display after the approval
            processes.
          </Alert>
          <a className="linkItem" target="_blank" href={certPreviewUrl}>
            Preview Certificate{" "}
            <i className="fa fa-certificate" title="Preview Certificate"></i>
          </a>
        </Row>
      ) : null}

      {showComments ? (
        <Row className="mb-3">
          <label
            htmlFor="comment_to_applicant"
            className="col-lg-3 col-form-label"
          >
            Comments to applicant
          </label>
          <div className="col-lg-9">
            <AvField
              disabled={props.success}
              type="textarea"
              id="comment_to_applicant"
              name="comment_to_applicant"
              //value={defaultValues.comment_to_applicant}
              rows="4"
              required
              className="form-control"
              onChange={v => {
                //setcomments(v.target.value)
              }}
            ></AvField>
          </div>
        </Row>
      ) : null}

      <FormGroup>
        <br></br>
        <Label for="minutesDocument">
          Minutes Document from Committee Meeting
        </Label>
        <br></br>
        <AvField
          className="btn"
          type="file"
          name="minutesDocument"
          id="minutesDocument"
          accept=".pdf,.doc,.docx"
          onChange={e => handleFileChange(e, setminutesDocument)}
          required={true}
        />
      </FormGroup>

      {props.loading && props.loading === true ? (
        <Link
          to="#"
          className="spinner-border text-info"
          style={{ float: "right" }}
        />
      ) : (
        <div className="mt-5">
          <button
            className="btn btn-lg btn-primary col-12"
            disabled={props.success}
            onClick={uploadDocuments}
          >
            Submit Review
          </button>
        </div>
      )}
    </>
  )
}

export default OfficerFormAccreditation
